export default "__VITE_ASSET__OBjfekho__"